module.exports = __webpack_public_path__ + "img/edge_activites_vtt.ec099ad0.svg";